import gsap from "gsap";
import $ from "jquery";

export default function Accordion() {
    if (document.querySelector('.customfaq')) {
        const groups = gsap.utils.toArray(".faq__item");
        const menus = gsap.utils.toArray(".faq__item--title");
        const animations = [];

        groups.forEach((group) => {
            createAnimation(group);
        });

        menus.forEach((menu) => {
            menu.addEventListener("click", () => toggleAnimation(menu));
        });

        function toggleAnimation(menu) {
            const selectedReversedState = menu.animation.reversed();
            animations.forEach((animation, index) => {
                animation.reverse();
                const parentGroup = groups[index];
                if (animation.reversed()) {
                    parentGroup.classList.remove("active");
                }
            });
            menu.animation.reversed(!selectedReversedState);

            if (!menu.animation.reversed()) {
                menu.closest(".faq__item").classList.add("active");
            }
        }

        function createAnimation(element) {
            const menu = element.querySelector(".faq__item--title");
            const box = element.querySelector(".faq__item--content");
            gsap.set(box, { height: "auto" });
            const tween = gsap.from(box, {
                height: 0,
                duration: 0.3,
                ease: "power1.inOut",
                reversed: true, 
            });
            menu.animation = tween; 
            animations.push(tween); 
        }

        toggleAnimation(menus[0]);
    }
}
